export default "__VITE_ASSET__CXWa$kJ0__"